import * as React from 'react';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var SvgClockIcon = function SvgClockIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    id: "KznpvV.tif",
    d: "M46.4,38.2c0-3.4,0-6.5,0-9.7c0.1-2.7,0.6-5,4-5c2.9,0,3.7,2.4,3.7,4.9c0,5.1-0.1,10.2-0.1,15.5 c0,3.5,1.2,5.3,3.8,7.2c3,2.3,6.2,4.6,9.3,6.9c2.1,1.5,2.9,3.5,1.4,5.6c-1.6,2.3-3.7,1.9-5.7,0.4c-4.5-3.4-9-6.8-13.6-10.2 c-1.9-1.4-2.7-3.3-2.7-5.6C46.4,44.8,46.4,42.1,46.4,38.2z M50,0C22.4,0,0,22.4,0,50c0,27.6,22.4,50,50,50c27.6,0,50-22.4,50-50 C100,22.4,77.6,0,50,0z M50,92.3C26.6,92.3,7.7,73.4,7.7,50C7.7,26.6,26.6,7.7,50,7.7S92.3,26.6,92.3,50 C92.3,73.4,73.4,92.3,50,92.3z",
    fill: props.color
  }));
};

export { SvgClockIcon as ReactComponent };
